import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('localidade') && (
        <Grid item xs={12}>
          <Input name="localidade" control={control} label="Localidade" />
        </Grid>
      )}
      {checkDisplay('sigla') && (
        <Grid item xs={12}>
          <Dropdown
            multiple
            name="sigla"
            control={control}
            label="Sigla"
            options={drops?.UF}
          />
        </Grid>
      )}
      {checkDisplay('cepbase') && (
        <Grid item xs={12}>
          <Input name="cepbase" control={control} label="CEP Base" />
        </Grid>
      )}
      {checkDisplay('codigo_ibge') && (
        <Grid item xs={12}>
          <Input
            name="codigo_ibge"
            control={control}
            label="Código IBGE"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('livrecom') && (
        <Grid item xs={12}>
          <Dropdown
            name="livrecom"
            control={control}
            label="Livre Comércio"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('codmunicipio') && (
        <Grid item xs={12}>
          <Input
            name="codmunicipio"
            control={control}
            label="Código do Município"
            type="number"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
